import angular from 'angular';
import config from './register-data.config';
import {RegisterData} from './register-data.component';
import ChangesRegisterDataDialogController from './changes-register-data/changes-register-data-dialog.controller';
import {ChangesRegisterData} from './changes-register-data/changes-register-data.component';

import './register-data.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.registerData', [])
  .component('registerDataComponent', RegisterData)
  .component('changesRegisterDataComponent', ChangesRegisterData)
  .controller('ChangesRegisterDataDialogController', ChangesRegisterDataDialogController)
  .config(config)
  .name;
